import gql from 'graphql-tag';
import { ProductAttributeOptionAllData } from '../fragments';

export default gql`
mutation updateProductAttributeOption (
    $id: ID!
    $label: String!
    $is_active: Boolean!
    $is_default: Boolean
    $product_attribute_id: ID!
    $after: ID
    $before: ID
) {
    updateProductAttributeOption (input: {
        id: $id
        label: $label
        is_active: $is_active
        is_default: $is_default
        product_attribute_id: $product_attribute_id
        after: $after
        before: $before
    }) {
        ...ProductAttributeOptionAllData
    }
}
${ProductAttributeOptionAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/updateProductAttributeOption.ts